import React, { VFC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core/styles';
import StarIcon from '@material-ui/icons/StarBorder';
import Styled from '../Styled';
import IconWithWord from './MuiIconWithWord';

// js codes
import { FAVORITE_PLANS } from '../../../constants/routing';

const { IconWrapper, IconLink } = Styled;

interface Props {}
const FavoritePlansIconLink: VFC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <IconWrapper theme={theme}>
      <IconLink href={FAVORITE_PLANS}>
        <IconWithWord Icon={StarIcon} word={t('header.menu.favoritePlans')} />
      </IconLink>
    </IconWrapper>
  );
};

export default FavoritePlansIconLink;
